import EntitySelector from "../../components/EntitySelector/EntitySelector";

const EntitySelectorPage = () => {
  return <EntitySelector />;
};

export default EntitySelectorPage;
